
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenSetInvoiceDiscountTypePubSub, OpenSetInvoiceDiscountTypePubSubPayload } from "@utils/pubsubs/PubSub";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import SetInvoiceDiscountTypeForm from "@components/forms/SetInvoiceDiscountTypeForm";
import { InvoiceDiscountTypeDataType } from "@/formTypes/InvoiceDiscountTypeDataType";

type SetInvoiceDiscountTypeOffCanvasProps = {
    onDiscountTypeChanged: (discountType?: InvoiceDiscountTypeDataType) => void
} & DefaultOffCanvasProps

const SetInvoiceDiscountTypeOffCanvas = (props: SetInvoiceDiscountTypeOffCanvasProps) => {
    const { btnColor = "primary", className, onDiscountTypeChanged } = props;
    const [defaultData, setDefaultData] = useState<InvoiceDiscountTypeDataType>({} as InvoiceDiscountTypeDataType);
    const [isOpen, setOpen] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        const unsubscribe = OpenSetInvoiceDiscountTypePubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenSetInvoiceDiscountTypePubSubPayload) => {
        const { openOffCanvas = false, discountType } = payload;
        setDefaultData({
            discountType
        })
        setOpen(openOffCanvas);
    }


    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const triggerDiscountTypeChange = (discountType?: InvoiceDiscountTypeDataType) => {
        try {
            if (onDiscountTypeChanged) {
                onDiscountTypeChanged(discountType)
            }
            onCanvasClosed()
        } catch (err) {
            if (err instanceof Error) {
                showAlert("danger", err.message)
            }

        } finally {
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Tipo de Descuento
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            Por favor seleccione como se manejara el descuento
                        </Alert>
                        <SetInvoiceDiscountTypeForm
                            onDiscountTypeChanged={triggerDiscountTypeChange}
                            defaultData={defaultData}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={showLoading} />
        </>
    );
}
export default SetInvoiceDiscountTypeOffCanvas;
